import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ChartType {
  AREA = 'area',
  CANDLESTICK = 'candlestick',
}

export enum Timeframe {
  ONE_DAY = 1,
  FIVE_DAYS = 2,
  ONE_MONTH = 3,
  THREE_MONTHS = 4,
  SIX_MONTHS = 5,
  YTD = 6,
  ONE_YEAR = 7,
  FIVE_YEARS = 8,
}

interface GraphState {
  chartType: ChartType;
  timeframe: Timeframe;
}

const initialState: GraphState = {
  chartType: ChartType.AREA,
  timeframe: Timeframe.ONE_MONTH,
};

const graphSlice = createSlice({
  name: 'graph',
  initialState,
  reducers: {
    setChartType(state, action: PayloadAction<ChartType>) {
      state.chartType = action.payload;
    },
    setTimeframe(state, action: PayloadAction<Timeframe>) {
      state.timeframe = action.payload;
    },
  },
});

export const { setChartType, setTimeframe } = graphSlice.actions;
export default graphSlice.reducer;
